var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFeaturesFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C12.4142 2.75 12.75 3.08579 12.75 3.5V5.5C12.75 5.91421 12.4142 6.25 12 6.25C11.5858 6.25 11.25 5.91421 11.25 5.5V3.5C11.25 3.08579 11.5858 2.75 12 2.75Z",
    fill: "url(#paint0_newFeatures)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C12.4142 17.75 12.75 18.0858 12.75 18.5V20.5C12.75 20.9142 12.4142 21.25 12 21.25C11.5858 21.25 11.25 20.9142 11.25 20.5V18.5C11.25 18.0858 11.5858 17.75 12 17.75Z",
    fill: "url(#paint0_newFeatures)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.25C20.9142 11.25 21.25 11.5858 21.25 12C21.25 12.4142 20.9142 12.75 20.5 12.75H18.5C18.0858 12.75 17.75 12.4142 17.75 12C17.75 11.5858 18.0858 11.25 18.5 11.25H20.5Z",
    fill: "url(#paint0_newFeatures)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.25C5.91421 11.25 6.25 11.5858 6.25 12C6.25 12.4142 5.91421 12.75 5.5 12.75H3.5C3.08579 12.75 2.75 12.4142 2.75 12C2.75 11.5858 3.08579 11.25 3.5 11.25H5.5Z",
    fill: "url(#paint0_newFeatures)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5303 5.46967C17.8232 5.76256 17.8232 6.23744 17.5303 6.53033L16.0607 8L17.5303 9.46967C17.8232 9.76256 17.8232 10.2374 17.5303 10.5303C17.2374 10.8232 16.7626 10.8232 16.4697 10.5303L14.4697 8.53033C14.1768 8.23744 14.1768 7.76256 14.4697 7.46967L16.4697 5.46967C16.7626 5.17678 17.2374 5.17678 17.5303 5.46967Z",
    fill: "url(#paint0_newFeatures)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53033 13.4697C7.82322 13.1768 8.2981 13.1768 8.591 13.4697L10.591 15.4697C10.8839 15.7626 10.8839 16.2374 10.591 16.5303L8.591 18.5303C8.2981 18.8232 7.82322 18.8232 7.53033 18.5303C7.23744 18.2374 7.23744 17.7626 7.53033 17.4697L9 16L7.53033 14.5303C7.23744 14.2374 7.23744 13.7626 7.53033 13.4697Z",
    fill: "url(#paint0_newFeatures)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12C8.25 9.92893 9.92893 8.25 12 8.25Z",
    fill: "url(#paint0_newFeatures)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_newFeatures",
    x1: 3.4,
    y1: 12,
    x2: 21.85,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFeaturesFilled);
export default __webpack_public_path__ + "static/media/newFeaturesFilled.dcb5a63ee36ba43bb96565dff77fb82c.svg";
export { ForwardRef as ReactComponent };